module.exports = __webpack_public_path__ + "static/img/leftlogo.cb2f69d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/leftlogo.png
// module id = U7Kj
// module chunks = 1